import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import Chip from 'Components/Molecules/Chip/Chip';
import useMediaQuery from 'Hooks/useMediaQuery';

const MAX_LENGTH = 32;
const MOBILE_MAX_LENGTH = 22;

const truncate = (str, length) => {
    if (str.length <= length) return str;
    return `${str.slice(0, length - 3)}...`;
};

export function formatTags(tagIds, { all: tagsData, maxLength }) {
    const filterTags = tagsData.filter((category) => tagIds.includes(category.id));
    const result = [];

    const children = filterTags.filter((category) => category.parent_tag_id !== null);

    filterTags.forEach((category) => {
        const hasParent = category.parent_tag_id !== null;
        if (hasParent) return;

        const subtags = children.filter((c) => c.parent_tag_id === category.id);
        const name = subtags.length > 0 ? `${category.name} > ${subtags.map((c) => c.name).join(', ')}` : category.name;
        const truncatedName = truncate(name, maxLength);

        result.push({
            ...category,
            name: truncatedName,
            tags_ids: [category.id, ...subtags.map((c) => c.id)],
        });
    });

    return result;
}

export default function TagsList(props) {
    const { tagIds = [], tags = [], className } = props;
    const isMobile = useMediaQuery('(max-width: 768px)');

    const formattedCategories = formatTags(tagIds, {
        all: tags,
        maxLength: isMobile ? MOBILE_MAX_LENGTH : MAX_LENGTH,
    });

    if (formattedCategories.length === 0) {
        return null;
    }

    return (
        <div className={cn('flex flex-wrap gap-1 min-w-0 max-w-full', className)}>
            {formattedCategories.map((category) => (
                <Chip key={category.id} color={category.color} icon={category.icon} className="truncate min-w-0">
                    {category.name}
                </Chip>
            ))}
        </div>
    );
}

TagsList.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    tagIds: PropTypes.arrayOf(PropTypes.string),
    tags: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            color: PropTypes.string,
            icon: PropTypes.string,
            parent_tag_id: PropTypes.string,
        }),
    ),
};
